import { getUnmaskedValue } from './InputMaskUtils';

export const getSearchText = (searchText) => {
  let splitedText = searchText.trim().split(' ');
  if (splitedText.length === 0) {
    return '';
  }
  let arr = [];
  splitedText.map((text, index) => {
    if (!isNaN(text.substr(0, 1))) {
      arr.push(getUnmaskedValue(text));
    } else {
      arr.push(text);
    }
    return index;
  });
  return arr.join(' ');
};
